import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable()
export class UtilDynamicBackground {
  body: Element;
  cssClass: string = 'bg-blue-curve';
  private url: string;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private route: Router
  ) {
  }

  setBackgroundImage(): void {
    this.body = this.document.getElementsByTagName('body')[0];
    this.body.classList.add(this.cssClass);
    this.checkUrl();
  }

  removeBackgroundImage(): void {
    if (this.body.classList.contains(this.cssClass)) {
      this.body.classList.remove(this.cssClass);
    }
  }

  checkUrl(): void {
    this.url = this.route.url;
    if (this.url.includes('payment')) {
      this.body.classList.add('bg-blue-curve--higher');
    }
  }
}
